import * as yup from 'yup';

export const blastingTechnicianInfo = yup.object().shape({
	name: yup.string().required('Name is required.'),
	address: yup.string().required('Address is required.'),
	state: yup.string().required('State is required.'),
	city: yup.string().required('City is required.'),
	zip: yup.string().required('Zip is required.'),
	officePhone: yup.string().required('Office phone is required.'),
	afterHourPhone: yup.string().required('After hour phone is required.'),
	driversLicenseNum: yup.string().required('License number is required.'),
	stateIssuedBy: yup.string().required('State issued by is required.'),
	dateOfBirth: yup.string().required('Date of birth is required.'),
});
